export const body_comprobante_pago_recibido = {
  schema: {
    type: 'object',
    properties: {
      file: { type: 'string', format: 'binary' },
      observacion: { type: 'string', nullable: true },
    },
    required: ['file'],
  },
};

export const response_comprobante_pago_recibido = {
  description: 'Comprobante registrado exitosamente',
  schema: {
    type: 'object',
    properties: {
      success: { type: 'boolean', example: true },
      message: { type: 'string', example: 'Comprobante registrado exitosamente' },
      data: { type: 'array', example: [] },
    },
  },
};
